import { axiosAWSConsumer as axiosConsumer } from "../../utils";

export const claimTicket = async (dto) => {
  const { data } = await axiosConsumer.post("/desk-ticket", dto);
  return data?.details || data;
};
